import React from 'react';

/** FlowFocus mark — a clean white clock on a navy tile. */
export function Logo({ size = 34, radius = 0.26 }: { size?: number; radius?: number }) {
  const r = size * radius;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" style={{ display: 'block', borderRadius: r, boxShadow: '0 1px 3px rgba(10,23,48,0.22)' }}>
      <rect width="100" height="100" rx="26" fill="#0A1730" />
      <circle cx="50" cy="50" r="32" fill="none" stroke="#ffffff" strokeWidth="5.5" />
      {/* tick marks */}
      {[0, 90, 180, 270].map((deg) => {
        const a = (deg * Math.PI) / 180;
        const x1 = 50 + Math.cos(a) * 28, y1 = 50 + Math.sin(a) * 28;
        const x2 = 50 + Math.cos(a) * 23, y2 = 50 + Math.sin(a) * 23;
        return <line key={deg} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#ffffff" strokeWidth="4" strokeLinecap="round" />;
      })}
      {/* hands */}
      <line x1="50" y1="50" x2="50" y2="30" stroke="#ffffff" strokeWidth="5.5" strokeLinecap="round" />
      <line x1="50" y1="50" x2="66" y2="56" stroke="#ffffff" strokeWidth="5.5" strokeLinecap="round" />
      <circle cx="50" cy="50" r="4.5" fill="#ffffff" />
    </svg>
  );
}
